import React, { ReactElement } from "react";
import { Link } from "react-router";

export interface DashboardItemProps {
  url: string;
  sectionImage: ReactElement;
  title: string;
  classes?: string;
  description?: string;
  transitionDelay?: string;
}

const DashboardItem: React.FC<DashboardItemProps> = (props: DashboardItemProps) => {
  const { sectionImage, url, classes, title, description, transitionDelay } = props;

  let descriptionContent = null;
  let classNameContent = "";

  if (description) {
    descriptionContent = <div className="dashboard-content-description">{description}</div>;
  }

  if (classes) {
    classNameContent = classes;
  }

  return (
    <div className="col dashboard-item" style={{ transitionDelay: transitionDelay }}>
      <Link to={url} className={classNameContent}>
        {sectionImage}
        <h6>{title}</h6>
        {descriptionContent}
      </Link>
    </div>
  );
};

export default DashboardItem;
